import React from 'react'
import { SidebarLabel } from '../load-details/sidebar/SidebarLabel'

export const LoadStatusHeader = () => <SidebarLabel BoxProps={{ pb: 2 }}>Status</SidebarLabel>
